import { EditOutlined, EyeInvisibleOutlined, EyeTwoTone, SearchOutlined } from "@ant-design/icons";
import { Badge, Button, Col, Flex, Form, Input, Modal, Row, Select, Space } from "antd";
import { useForm } from "antd/es/form/Form";
import { Alert } from "components/elements";
import TableAntd from "components/elements/Table/Table";
import { FormDatePicker, FormInput, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import dayjs from "dayjs";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import * as services from "../services/whiteListApi";
import { setIsLoading, setLoanTransferStatus, setRequestLoanList } from "../slices/whiteListSlice";
import styles from "../styles/BeCashStyles.module.css";
import { ReactComponent as DownloadIcon } from "../../../assets/icon/downloadIcon.svg";

const useBeCash = () => {

    const { t, i18n } = useTranslation();
    const [form] = useForm();
    const dispatch = useDispatch();
    const { requestLaonList, loanTransferStatus, isLoading } = useSelector((state) => state?.whitelist)
    const [transferStatus, setTransferStatus] = useState(null)
    const [year, setYear] = useState(dayjs().format('YYYY'))
    const [month, setMonth] = useState(dayjs().format('MM'))
    const [dataSource, setDataSource] = useState([])
    const [filter, setFilter] = useState("");

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [dataModal, setDataModal] = useState({})
    const [amountVisible, setAmountVisible] = useState(true)
    const [pagination, setPagination] = useState({ page: 0, size: 10, pageSize: 10 });
    const [isDownloading, setIsDownloading] = useState(false);

    const showModal = (record) => {
        setIsModalOpen(true);
        setDataModal(record)
    };

    const handleOk = () => {
        form.submit()
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };


    function tagContractStatus(status) {
        switch (status) {
            case "รอโอนเงิน":
                return (
                    <Badge color="#FFBF1A" style={{ backgroundColor: "#FFF8E0", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#FFBF1A" }} text={status} />
                )
            case "เปิดสัญญา":
                return (
                    <Badge color="#12B76A" style={{ backgroundColor: "#ECFDF3", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#027A48" }} text={status} />
                )
            case "ปิดใช้งาน":
                return (
                    <Badge color="#667085" style={{ backgroundColor: "#EAEBEC", borderRadius: "16px", padding: "2px 8px", color: "#667085" }} text={status} />
                )
            case "OPEN":
                return (
                    <Badge color="#F15046" style={{ backgroundColor: "#FFF2EA", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#F15046" }} text={status} />
                )
            default: return ("")
        }
    }

    const transactionColumn = [
        {
            title: <div className="text-table">{t('common.index')}</div>,
            dataIndex: "index",
            key: "index",
            width: "100px",
            align: "center",
            render: (_, record, idx) => {

                return (pagination.page) * pagination.size + idx + 1;
            },
        },
        {
            title: <div className="text-table">{t('whitelist.contract_number')}</div>,
            dataIndex: "requestCode",
            key: "requestCode",
            width: "160px",
            align: "center"
        },
        {
            title: <div className="text-table">{t('whitelist.employeeId')}</div>,
            dataIndex: "employeeId",
            key: "employeeId",
            width: "120px",
            align: "center",
            render: (_, record) => {
                return (
                    _.code
                )
            }
        },
        {
            title: <div className="text-table">{t('user_management.label.fullname')}</div>,
            dataIndex: "fullName",
            key: "fullName",
            width: "170px",
            align: "left",
        },
        {
            title: <div className="text-table" >{t('whitelist.maximum_credit')}</div>,
            dataIndex: "creditLimit",
            key: "creditLimit",
            width: i18n.language === "en" ? "180px" : "120px",
            align: "right",
            render: (_, record) => {
                return (
                    get2DecimalPointsWithCommas(record?.creditLimit)
                )
            }
        },
        {
            title: <div className="text-table" >{t('whiteList.bankNo')}</div>,
            dataIndex: "bankNo",
            key: "bankNo",
            width: i18n.language === "en" ? "150px" : "120px",
            align: "center",
            render: (_, record) => {
                let leng = _?.length && _?.length > 4 ? 4 : _?.length ?? 0
                let regex = new RegExp(`\\d{${leng}}$`);
                if (amountVisible) return _?.replace(regex, "XXXX")
                return (
                    _
                )
            }
        },
        {
            title: <div className="text-table" >{t('whitelist.request_amount')}</div>,
            dataIndex: "creditUsage",
            key: "creditUsage",
            width: i18n.language === "en" ? "180px" : "120px",
            align: "right",
            render: (_, record) => {
                return (
                    get2DecimalPointsWithCommas(record?.creditUsage)
                )
            }
        },
        {
            title: <div className="text-table" >{t("whitelist.fee")}</div>,
            dataIndex: "feeAmount",
            key: "feeAmount",
            width: "120px",
            align: "right",
            render: (_, record) => {
                return (
                    get2DecimalPointsWithCommas(record?.feeAmount)
                )
            }
        },
        {
            title: <div className="text-table" >{t("whitelist.request_date")}</div>,
            dataIndex: "requestDate",
            key: "requestDate",
            align: "center",
            width: i18n.language === "en" ? "180px" : "120px",
            render: (_, record) => {
                return (
                    dayjs(record?.requestDate).format(i18n.language == "en" ? "DD/MM/YYYY" : "DD/MM/BBBB")
                )
            }
        },
        {
            title: <div className="text-table" >{t("whitelist.transfer_date")}</div>,
            dataIndex: "transferDate",
            key: "transferDate",
            align: "center",
            width: "120px",
            render: (_, record) => {
                return (
                    <span>{record?.transferDate?.format?.(i18n.language == "en" ? "DD/MM/YYYY" : "DD/MM/BBBB")} </span>
                )
            }
        },
        {
            title: <div className="text-table" >{t("whitelist.contract_status")}</div>,
            dataIndex: "status",
            key: "status",
            align: "center",
            width: i18n.language === "en" ? "180px" : "120px",
            render: (_, record) => {
                return tagContractStatus(record?.status)
            }
        },
        {
            title: <div className="text-table" >{t("whitelist.transfer_status")}</div>,
            dataIndex: "transferStatus",
            key: "transferStatus",
            align: "center",
            width: i18n.language === "en" ? "150px" : "120px",
            fixed: "right",
            render: (_, record) => {
                if (i18n.language === "en") {
                    return <span>{record?.transferStatus?.nameEN} <EditOutlined onClick={() => { showModal(record) }} /></span>;
                }
                return <span>{record?.transferStatus?.name} <EditOutlined onClick={() => { showModal(record) }} /></span>;
            }
        },
    ]

    const getRequestLoanList = useCallback(async (value = null, year, month) => {
        try {
            dispatch(setIsLoading(true));
            const response = await services.getRequestLoanListByCompany({
                transferStatus: value,
                year,
                month,
                ...pagination,
                page: 0,
                filter
            });
            // console.log("response", response);
            dispatch(setRequestLoanList(response.data?.page?.content || []));
            setPagination({
                ...pagination,
                page: 0,
                current: 1,
                total: response.data?.page?.totalElements,
            });
        } catch (error) {
            Alert({ type: "error", resultObject: error });
        } finally {
            dispatch(setIsLoading(false));
        }
    }, [transferStatus, pagination, filter]);

    console.log("pagination", pagination);


    const getRequestLoanListPage = useCallback(
        async (pagination) => {
            try {
                dispatch(setIsLoading(true));
                const response = await services.getRequestLoanListByCompany({
                    transferStatus,
                    ...pagination,
                    year,
                    month
                });
                // console.log("response", response);
                dispatch(setRequestLoanList(response.data?.page?.content || []));
                setPagination({
                    ...pagination,
                    total: response.data?.page?.totalElements,
                });
            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        }, [transferStatus, year, month]);

    const exportWelfareLoan = useCallback(
        async (params = {}) => {
            setIsDownloading(true);
            try {
                const res = await services.exportWelfareLoanFile({
                    transferStatus,
                    year,
                    month,
                    ...pagination,
                });

                const url = window.URL.createObjectURL(res?.data);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', "welfare loan.xlsx");
                document.body.appendChild(link);
                link.click();
                link.remove();
            } catch (error) {
                console.error("Error fetching report history:", error);
            } finally {
                setIsDownloading(false);
            }
        },
        [month, pagination, transferStatus, year]
    );


    console.log("isdownload", isDownloading);

    const getLoanTransferStatus = useCallback(async () => {
        dispatch(setIsLoading(true));
        try {
            const response = await services.getLoanTransferStatus({
                employeeNo: "202020",
                page: "0",
                size: "10"
            });

            console.log("tranfer status", setLoanTransferStatus);
            dispatch(setLoanTransferStatus(response?.data?.content));
        } catch (error) {
            console.error(error);
        } finally {
            dispatch(setIsLoading(false));
        }
    }, []);

    const updateTxnRequest = useCallback(
        async (values = {}) => {
            try {
                dispatch(setIsLoading(true));
                await services.getUpdateTxnRequest({
                    txnId: values?.id,
                    status: values?.transferStatus,
                    date: values?.transferDate?.format?.("YYYY-MM-DDT00:00:00")
                });
                getRequestLoanList(transferStatus);
            } catch (error) {

            } finally {
                dispatch(setIsLoading(false));
                setIsModalOpen(false);
            }
        }, [dispatch, getRequestLoanList, transferStatus]
    );

    const onSubmit = useCallback(
        (values) => {
            console.log("values", values);
            Modal.confirm({
                title: "Confirmation",
                content: (
                    <p>
                        {(values.id &&
                            (t("dialog.confirmation.edit"))
                        ).replace("{entity}", t("whitelist.transfer_status"))}
                    </p>
                ),
                onOk() {
                    if (values.id) {
                        updateTxnRequest(values)
                    }
                }
            }
            );
        }, [updateTxnRequest])

    useEffect(() => {
        getLoanTransferStatus()
        getRequestLoanList(transferStatus, year, month)
    }, [])

    const loanTransferStatusOption = useMemo(() => {
        let temp = [{
            label: "",
            value: null
        }, ...loanTransferStatus?.map?.(o => {
            return {
                label: (i18n.language === "en" ? o?.nameEn : o?.name),
                value: o.code
            }
        })]
        return temp;
    }, [loanTransferStatus])

    useEffect(() => {
        setDataSource(requestLaonList?.map?.((o, index) => {
            return {
                index,
                ...o,
                fullName: o?.employeeId?.name + " " + o?.employeeId?.surname,
                status: o?.status?.name,
                transferDate: o?.transferDate == null ? null : dayjs(o?.transferDate)
            }
        }))
    }, [requestLaonList])
    const months = [
        { label: i18n.language == 'en' ? 'January' : 'มกราคม', value: '01' },
        { label: i18n.language == 'en' ? 'February' : 'กุมภาพันธ์', value: '02' },
        { label: i18n.language == 'en' ? 'March' : 'มีนาคม', value: '03' },
        { label: i18n.language == 'en' ? 'April' : 'เมษายน', value: '04' },
        { label: i18n.language == 'en' ? 'May' : 'พฤษภาคม', value: '05' },
        { label: i18n.language == 'en' ? 'June' : 'มิถุนายน', value: '06' },
        { label: i18n.language == 'en' ? 'July' : 'กรกฎาคม', value: '07' },
        { label: i18n.language == 'en' ? 'August' : 'สิงหาคม', value: '08' },
        { label: i18n.language == 'en' ? 'September' : 'กันยายน', value: '09' },
        { label: i18n.language == 'en' ? 'October' : 'ตุลาคม', value: '10' },
        { label: i18n.language == 'en' ? 'November' : 'พฤศจิกายน', value: '11' },
        { label: i18n.language == 'en' ? 'December' : 'ธันวาคม', value: '12' },
    ]

    function menu() {
        return (
            <Row justify="space-between" align={"bottom"}>
                <Space size={8} align="end">
                    <Input
                        name="filter"
                        value={filter}
                        style={{ borderRadius: "8px", width: i18n.language == "en" ? "350px" : "300px" }}
                        size="large"
                        placeholder={`${t("user_management.label.fullname")}, ${t("employee.label.employee_no")}, ${t("whitelist.contract_number")}`}
                        onChange={(e) => {
                            const value = e.target.value;
                            setFilter(value);
                        }}
                        allowClear
                        onClear={() => {
                            setFilter("");
                            getRequestLoanList();
                        }}
                    />
                    <Button
                        size="large"
                        style={{ color: "#667085", borderRadius: "8px", boxShadow: "none" }}
                        onClick={() => { getRequestLoanList(transferStatus, year, month, filter) }}
                    >
                        {t("common.search")}
                    </Button>
                </Space>

                <Space size={8}>
                    <Button
                        size="large"
                        style={{
                            boxShadow: "none", color: "#344054", borderRadius: "8px"
                        }}
                        onClick={() => { setAmountVisible(!amountVisible) }}
                        icon={amountVisible ? <EyeInvisibleOutlined /> : <EyeTwoTone />}
                    />
                    <Select
                        allowClear
                        value={year}
                        onClear={() => {
                            console.log("clear");
                            setYear(null)
                            getRequestLoanList(transferStatus, null, month)
                        }} onSelect={(e) => {
                            setYear(e)
                            getRequestLoanList(transferStatus, e, month)
                        }}
                        className={styles.selectButton}
                        placeholder={t("unit.year")}
                        options={[
                            { label: i18n.language == 'en' ? "2025" : "2568", value: "2025" },
                            { label: i18n.language == 'en' ? "2024" : "2567", value: "2024" },
                            { label: i18n.language == 'en' ? "2023" : "2566", value: "2023" }
                        ]}
                        popupMatchSelectWidth={false}
                        size="large"
                    />
                    <Select
                        allowClear
                        value={month}
                        onClear={() => {
                            console.log("clear");
                            setMonth(null)
                            getRequestLoanList(transferStatus, year, null)
                        }} onSelect={(e) => {
                            setMonth(e)
                            getRequestLoanList(transferStatus, year, e)
                        }}
                        className={styles.selectButton}
                        placeholder="เดือน"
                        options={months}
                        popupMatchSelectWidth={false}
                        size="large"
                    />
                    <Select
                        allowClear
                        onClear={() => {
                            console.log("clear");
                            setTransferStatus(null)
                            getRequestLoanList(null, year, month)
                        }} onSelect={(e) => {
                            setTransferStatus(e)
                            getRequestLoanList(e, year, month)
                        }}
                        className={styles.selectButton}
                        placeholder={t("whitelist.all")}
                        options={loanTransferStatusOption}
                        popupMatchSelectWidth={false}
                        size="large"
                    />
                    <Button
                        type="default"
                        onClick={exportWelfareLoan}
                        style={{ padding: "8px 16px", borderRadius: "8px", display: "flex", alignItems: "center" }}
                        size="large"
                        loading={isDownloading}
                        disabled={isDownloading}
                    >
                        <Flex align="center" justify="center" gap={8}>
                            {!isDownloading && (
                                <DownloadIcon color="#667085" />
                            )}
                            <span style={{ color: "#667085" }}>{t('common.download')}</span>
                        </Flex>
                    </Button>
                </Space>
            </Row>
        )
    }

    function transactionTable() {
        return (
            <TableAntd
                loading={isLoading}
                columns={transactionColumn}
                dataSource={dataSource}
                scroll={{ x: "1000px" }}
                onChange={(pagination) => {
                    getRequestLoanListPage({
                        page: pagination?.current - 1,
                        size: pagination?.pageSize,
                        pageSize: pagination?.pageSize,
                    })
                    setPagination({
                        page: pagination?.current - 1,
                        size: pagination?.pageSize,
                        pageSize: pagination?.pageSize,
                    })
                }}
                pagination={{
                    ...pagination,
                    showTotal: (total, range) =>
                        t("paginate.description")
                            .replace("{min}", range[0])
                            .replace("{max}", range[1])
                            .replace("{total}", total),
                }} />
        )
    }

    const statusChangeModal = useCallback(
        () => {
            form.setFieldsValue({ id: dataModal.id, transferStatus: dataModal?.transferStatus?.code, transferDate: dataModal?.transferDate })
            return (
                <Modal title={t("whitlist.change_transfer_status")} open={isModalOpen} closable={false} destroyOnClose
                    footer={[
                        <Button onClick={handleCancel}>{t("common.cancel")}</Button>,
                        <Button
                            htmlType="submit"
                            type="primary"
                            onClick={handleOk}>{t("common.submit")}</Button>
                    ]}
                >
                    <FormAntd
                        form={form}
                        // initialValues={}
                        onFinish={onSubmit}
                    >
                        <Form.Item shouldUpdate>
                            <Row gutter={24}>
                                <Col span={12}>
                                    <FormDatePicker name="transferDate" label={t("whitlist.transfer_date")} placeholder={t("common.pleaseSelect")} />
                                </Col>
                                <Col span={12}>
                                    <FormSelect name="transferStatus" label={t("whitelist.transfer_status")} placeholder={t("common.pleaseSelect")} options={loanTransferStatusOption} />
                                </Col>
                            </Row>
                        </Form.Item>
                    </FormAntd>
                </Modal>
            )
        },
        [form, dataModal, isModalOpen, loanTransferStatusOption, onSubmit, t],
    )

    return {
        menu,
        transactionTable,
        statusChangeModal
    }
}

export default useBeCash;